/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/* Import configuration */
import {
    MUENSTER_DEVICE_CATEGORY_BY_PREFIX,
    MUENSTER_DEVICE_CATEGORY_LABELS,
    MUENSTER_UNKNOWN_DEVICE_CATEGORY,
} from '@/config/muensterDeviceCategories';

/* Import types */
import type { MuensterDeviceCategory } from '@/types/deviceSensor';

export function getMuensterDeviceCategory(
    deviceName: string,
): MuensterDeviceCategory | null {
    if (!deviceName.startsWith('Mue.')) {
        return null;
    }

    const deviceType = deviceName.split('.')[2]?.split('_')[0] ?? '';

    return MUENSTER_DEVICE_CATEGORY_BY_PREFIX[deviceType]
        ?? MUENSTER_UNKNOWN_DEVICE_CATEGORY;
}

export function getMuensterDeviceCategoryLabel(
    category: MuensterDeviceCategory | null,
): string | null {
    if (!category) {
        return null;
    }

    return MUENSTER_DEVICE_CATEGORY_LABELS[category];
}
